// extracted by mini-css-extract-plugin
export var container = "layout-module--container--YM7Lx";
export var heading = "layout-module--heading--2By-2";
export var navLinks = "layout-module--nav-links--1VlO2";
export var navLinkItem = "layout-module--nav-link-item--31U8T";
export var navLinkText = "layout-module--nav-link-text--ExV28";
export var siteTitle = "layout-module--site-title--16llq";
export var siteFooter = "layout-module--site-footer--3htEm";